var map = {
	"./americano.png": 5162,
	"./americano.webp": 1811,
	"./boulevardier.png": 2421,
	"./boulevardier.webp": 6035,
	"./campari-soda.png": 3230,
	"./campari-soda.webp": 7993,
	"./mi-to.png": 1792,
	"./negroni.png": 6297,
	"./negroni.webp": 824,
	"./shakerato.png": 2734,
	"./shakerato.webp": 4365,
	"./spritz.png": 1780,
	"./spritz.webp": 8099
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5395;